const PADCHAR = "=";
const ALPHA =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

export default {
  encode: function encode(s: string): string {
    if (!s) {
      return "";
    }

    s = String(s);

    let i,
      b10,
      result = [],
      imax = s.length - (s.length % 3);

    if (s.length === 0) {
      return s;
    }

    for (i = 0; i < imax; i += 3) {
      b10 =
        (getByte(s, i) << 16) | (getByte(s, i + 1) << 8) | getByte(s, i + 2);
      result.push(ALPHA.charAt(b10 >> 18));
      result.push(ALPHA.charAt((b10 >> 12) & 63));
      result.push(ALPHA.charAt((b10 >> 6) & 63));
      result.push(ALPHA.charAt(b10 & 63));
    }

    switch (s.length - imax) {
      case 1:
        b10 = getByte(s, i) << 16;
        result.push(
          ALPHA.charAt(b10 >> 18) +
            ALPHA.charAt((b10 >> 12) & 63) +
            PADCHAR +
            PADCHAR
        );
        break;
      case 2:
        b10 = (getByte(s, i) << 16) | (getByte(s, i + 1) << 8);
        result.push(
          ALPHA.charAt(b10 >> 18) +
            ALPHA.charAt((b10 >> 12) & 63) +
            ALPHA.charAt((b10 >> 6) & 63) +
            PADCHAR
        );
        break;
      default:
        break;
    }

    return result.join("");
  },
};

function getByte(s: string, i: number): number {
  return s.charCodeAt(i);
}
